import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryItemRequestApprovalLog } from "./thunk";

interface initialStateType {
  itemRequestApprovalLogList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: initialStateType = {
  itemRequestApprovalLogList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryItemRequestitemRequestApprovalLogSlice = createSlice({
  name: "InventoryItemRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryItemRequestApprovalLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryItemRequestApprovalLog.fulfilled, (state, action) => {
        state.loading = false;
        state.itemRequestApprovalLogList = action.payload.data;   // now proper array
        state.rowCount = action.payload.rowCount;                // now correct number
      })

      .addCase(fetchInventoryItemRequestApprovalLog.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Item Request Approval Log";
      });
  },
});

export default InventoryItemRequestitemRequestApprovalLogSlice.reducer;
